export const Text = {
    baseStyle: {
        mb: 6,
        '&:last-child': {
            mb: 0,
        },
    },
}
